import { useState } from "react";
import {
    FiDollarSign,

    FiSave,
    FiX,
    FiXCircle,
} from "react-icons/fi";

export default function AporteForm({ meta, onClose, onSave }) {
    const [form, setForm] = useState({
        fechaAporte: "",
        monto: "",
        observacion: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSave({
            ...form,
            monto: Number(form.monto || 0),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiDollarSign size={20} />
                        Aporte a meta: {meta?.nombre}
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Fecha de aporte</label>
                        <div style={{ position: "relative" }}>
                            <input
                                type="date"
                                name="fechaAporte"
                                value={form.fechaAporte}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div>
                        <label>Monto</label>
                        <input
                            type="number"
                            step="0.01"
                            name="monto"
                            placeholder="Monto"
                            value={form.monto}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="full-width">
                        <label>Observación</label>
                        <textarea
                            className="full-width"
                            name="observacion"
                            placeholder="Observación"
                            value={form.observacion}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button className="btn-secondary" type="button" onClick={onClose}>
                            <FiXCircle size={16} />
                            Cancelar
                        </button>

                        <button className="btn-primary" type="submit">
                            <FiSave size={16} />
                            Guardar aporte
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}